export default __webpack_public_path__ + "static/media/ico_coach.acbda6ac.svg";